// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Es6Promise from 'es6-promise'    // import es6Promise
// Es6Promise.polyfill()                   // Use es6Promise for polyfill to support app use in internet explorer

import Vue from 'vue'
import Vuetify from 'vuetify'
Vue.use(Vuetify);
// import 'vuetify/dist/vuetify.css'
// app.js




// import Swal from 'sweetalert2';
import './stylus/main.styl'
import App from './App'
import router from './router'
import axios from 'axios'
import moment from 'moment'
import VueSweetalert2  from 'vue-sweetalert2'
import VueAxios from 'vue-axios'
import Buefy from 'buefy'
// import 'buefy/dist/buefy.css'
import store from './store';
import VueLocalStorage from 'vue-localstorage'

Vue.use(moment);
Vue.use(VueSweetalert2);

// Initialize indexedDB on the project
import Dexie from 'dexie';


// declare the containing variables to hold data
let stateNumDenData = new Array;
let lgaNumDenData = new Array;

//Call the Data fetching function
 getApiData();


 // Create the database
let iDB = new Dexie('MSDAT-DATABASE');
const version = 1;

  iDB.version(version).stores({
//Create the tables
    stateNumDen: '++id',
    lgaNumDen:  '++id',
    users:  '++id, user_id, name, email, profession, organization, username, password',
    sub_dashboard_interests:  '++id, email, dashboard, created',
    transactions:  '++id'
  });
  


// the Data fetching function
async function  getApiData(){
  
    try {
       await axios.get(`https://car-dashboard-others.firebaseio.com/ndState.json`)        
           .then(response => {
                    stateNumDenData.push(response.data);
                    return stateNumDenData;
               })
           } catch (e) {
            //    console.log(e)
           }




           try {
            //await axios.get(`https://car-dashboard-others.firebaseio.com/ndlga.json`)        
                //.then(response => {
                         // console.log(values);
                        // lgaNumDenData.push(response.data);
                        // return lgaNumDenData;
                   // })
                } catch (e) {
                 //    console.log(e)
                }
   



      //  console.log(stateNumDenData[0]);
      //  console.log(lgaNumDenData[0]);


       
  //  Check if there's internet to either update data on the tables or skip the updata
  //  
   var ifConnected = window.navigator.onLine;

   if (ifConnected) {
     //Data updates
    console.log('Connection available, Database will Update');
     iDB.transaction('rw', iDB.stateNumDen, () => {

      //Clear the stateNumDen table
      iDB.stateNumDen.clear();

       //Refill the table with latest data
        const objs = stateNumDenData[0];
        
          for (const o of objs) {
              iDB.stateNumDen.put(o);
          }

          }).catch(function (e) {
            // handle errors
            });

  
  iDB.transaction('rw', iDB.lgaNumDen, () => {

     //Clear the lgaNumDen table
    iDB.lgaNumDen.clear();
     //Refill the table with latest data
      const data = lgaNumDenData[0];

        for (const d of data) {
            iDB.lgaNumDen.put(d);
        }
        
        
      }).catch(function (e) {
        
        });

   } else {
      //Data Does not update because there's no internet
     console.log('Connection not available, Database will not Update');
   }

   
          
}
//Export for use by other components
export let indDB = iDB;








// import config from '../config';
// sync route to vuex store so you can access route object
// with store.state.route.{name|path|param|query}
import { sync } from 'vuex-router-sync';

//require('./assets/js-on/bootstrap-tour');
require('./assets/js-on/intro');   
sync(store, router);

// import fullscreen from 'vue-fullscreen'
// Vue.use(fullscreen, {
//   name: 'fullscreen',
//   createComputed: true, //created computed members from your variable declarations
//   // bind: true
// })

import VueGoodTable from '@/assets/js-on/vue-good-table';    //'vue-good-table';
import VueCookies from 'vue-cookies'
// import high chart
import VueHighcharts from 'vue-highcharts';
import Highcharts from 'highcharts';
import NoData from 'highcharts/modules/no-data-to-display';
NoData(Highcharts);
// import Highcharts from 'highcharts/highstock';

// load these modules as your need
import loadStock from 'highcharts/modules/stock';
import loadMap from 'highcharts/modules/map';
import loadDrilldown from 'highcharts/modules/drilldown';
// some charts like solid gauge require `highcharts-more.js`, you can find it in official demo.
import loadHighchartsMore from 'highcharts/highcharts-more';
import loadSolidGauge from 'highcharts/modules/solid-gauge';
import loadExporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import loadOfflineExporting from 'highcharts/modules/offline-exporting';
// to boost the rendering speed by reducing animations and other stuff that takes rendering time
import loadBoost from 'highcharts/modules/boost'
import _ from 'lodash'

loadStock(Highcharts);
loadMap(Highcharts);
loadDrilldown(Highcharts);
loadHighchartsMore(Highcharts);
loadSolidGauge(Highcharts);
loadExporting(Highcharts);
loadOfflineExporting(Highcharts);
// load up the boost modules
loadBoost(Highcharts);
ExportData(Highcharts);

//Overwrite highchart legend function to highlight hovered item
// (function(H) {
//   H.Legend.prototype.setItemEvents = function(item, legendItem, useHTML) {
//     var legend = this,
//       merge = H.merge,
//       fireEvent = H.fireEvent,
//       Point = H.Point,
//       boxWrapper = legend.chart.renderer.boxWrapper,
//       activeClass = 'highcharts-legend-' +
//       (item instanceof Point ? 'point' : 'series') + '-active';

//     if (!item.initColor) {
//       item.initColor = item.color;
//     }
//     // Set the events on the item group, or in case of useHTML, the item
//     // itself (#1249)
//     (useHTML ? legendItem : item.legendGroup)
//     .on('mouseover', function() {
//         item.setState('hover');

//         // A CSS class to dim or hide other than the hovered series
//         boxWrapper.addClass(activeClass);

//         legendItem.css(legend.options.itemHoverStyle);

//         // item.graph.attr({
//         //   stroke: 'red'
//         // });

//         // item.points.forEach(function(point) {
//         //   point.graphic.attr({
//         //     fill: 'red'
//         //   });
//         // });

//       })
//       .on('mouseout', function() {

//         legendItem.css(
//           merge(item.visible ? legend.itemStyle : legend.itemHiddenStyle)
//         );


//         // A CSS class to dim or hide other than the hovered series
//         boxWrapper.removeClass(activeClass);

//         item.setState();

//         item.graph.attr({
//           stroke: item.initColor
//         });

//         item.points.forEach(function(point) {
//           point.graphic.attr({
//             fill: item.initColor
//           });
//         });
//       })
//       .on('click', function(event) {
//         var strLegendItemClick = 'legendItemClick',
//           fnLegendItemClick = function() {
//             if (item.setVisible) {
//               item.setVisible();
//             }
//           };

//         // A CSS class to dim or hide other than the hovered series. Event
//         // handling in iOS causes the activeClass to be added prior to click
//         // in some cases (#7418).
//         boxWrapper.removeClass(activeClass);

//         // Pass over the click/touch event. #4.
//         event = {
//           browserEvent: event
//         };

//         // click the name or symbol
//         if (item.firePointEvent) { // point
//           item.firePointEvent(
//             strLegendItemClick,
//             event,
//             fnLegendItemClick
//           );
//         } else {
//           fireEvent(item, strLegendItemClick, event, fnLegendItemClick);
//         }
//       });
//   }
// })(Highcharts);

//  Fade other series on hover
(function (Highcharts) {
  var each = Highcharts.each;
  
  Highcharts.wrap(Highcharts.Legend.prototype, 'renderItem', function (proceed, item) {
      
      proceed.call(this, item);
      
      
      var isPoint = !!item.series,
          collection = isPoint ? item.series.points : this.chart.series,
          groups = isPoint ? ['graphic'] : ['group', 'markerGroup'],
          element = item.legendGroup.element;
      
      element.onmouseover = function () {
         each(collection, function (seriesItem) {
              if (seriesItem !== item) {
                  each(groups, function (group) {
                      seriesItem[group].animate({
                          opacity: 0.25
                      }, {
                          duration: 150
                      });
                  });
              }
          });
      }
      element.onmouseout = function () {
         each(collection, function (seriesItem) {
              if (seriesItem !== item) {
                  each(groups, function (group) {
                      seriesItem[group].animate({
                          opacity: 1
                      }, {
                          duration: 50
                      });
                  });
              }
          });
      }           
      
  });
}(Highcharts));

Highcharts.SVGRenderer.prototype.symbols.download = function (x, y, w, h) {
  var path = [
      // Arrow stem
      'M', x + w * 0.5, y,
      'L', x + w * 0.5, y + h * 0.7,
      // Arrow head
      'M', x + w * 0.3, y + h * 0.5,
      'L', x + w * 0.5, y + h * 0.7,
      'L', x + w * 0.7, y + h * 0.5,
      // Box
      'M', x, y + h * 0.9,
      'L', x, y + h,
      'L', x + w, y + h,
      'L', x + w, y + h * 0.9
  ];
  return path;
};

Object.defineProperty(Vue.prototype, '$_', { value: _ });

Vue.use(VueHighcharts, { Highcharts: Highcharts });
// Vue.use(VueHighcharts, { Highcharts });

// new components with firebase, graphql, and mongoDB
// import * as firebase from 'firebase/app';
// import 'firebase/auth';
import VueFirestore from 'vue-firestore'
Vue.use(VueFirestore)

Vue.use(VueCookies);
var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "linear",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
});
export const eventBus = new Vue();
import Tooltip from 'vue-directive-tooltip';
Vue.use(Tooltip);
import VueTour from 'vue-tour';
Vue.use(VueTour);

Vue.use(VueAxios, axios);
Vue.use(Vuetify);
Vue.use(VueLocalStorage, {
  name: 'ls',
  createComputed: true //created computed members from your variable declarations
});
Vue.use(Buefy);
Vue.use(VueGoodTable);
Vue.config.productionTip = false
// use v-focus directive
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted: function (el) {
    // Focus the element
    el.focus()
  }
});

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
});

// add custom js codes
function launchApplication(l_url, l_windowName)
{
  // window.name = 'web';
  // console.log(window)
  if ( typeof launchApplication.winrefs == 'undefined' ){
    launchApplication.winrefs = {};
  }
  if ( typeof launchApplication.winrefs[l_windowName] == 'undefined' || launchApplication.winrefs[l_windowName].closed ){
    launchApplication.winrefs[l_windowName] = window.open(l_url, l_windowName);
  }else {
    launchApplication.winrefs[l_windowName].focus();
  }
}





// WEBPACK FOOTER //
// ./src/main.js